export default __webpack_public_path__ + "static/oktober1st-f043c5ba388cb3516199825206784291.png";